export const themeInitialState = {
  darkMode: false,
  themeData: null
};

export const themeActionTypes = {
  LIGHTMODE: 'LIGHTMODE',
  DARKMODE: 'DARKMODE',
  SET_THEME: 'SET_THEME'
};
